export const PAGE_STATES = {
  FIND_CLINIC: 0,
  CLINIC_LIST: 1,
  ASSOCIATE_SUCCESS: 2,
  ASSOCIATE_ERROR: 3,
  DESTROY_ALERT: 4,
  DESTROY_CONFIRM: 5,
};
